/**
 * Debug mode
 * enable with ?debug=[Level] url param or by calling Common.debugLevel( [Level] )
 */
import {isWebkit, isSafari} from '../utils/browser';

var _DEBUG;

	// debug mode
export const debug = function(isWebkit) {
	var base = 'margin:0;padding:2px 4px;line-height:24px', // base style
		bg = ';background:#',
		br = ';border:1px solid #',
		co = ';color:#',
		style = [
			co+'c09853'+bg+'fcf8e3'+br+'fbeed5', // notification
			co+'b94a48'+bg+'f2dede'+br+'eed3d7', // errors
			co+'468847'+bg+'dff0d8'+br+'d6e9c6', // success
			co+'3a87ad'+bg+'d9edf7'+br+'bce8f1'  // debugging
		],
	// check safari version will support this (function lifted from //github.com/adamschwartz/log)
		safariSupport = function() {
			var m = navigator.userAgent.match(/AppleWebKit\/(\d+)\.(\d+)(\.|\+|\s)/);
			if (!m) {
				return false;
			}
			return 537.38 <= parseInt(m[1], 10) + (parseInt(m[2], 10) / 100);
		},
	// create the style array if there is matching style and the value is a string
		buildArr = function(val, level) {
			var css = style[style.length >= level? level: 0], type = typeof val;
			return (type === 'string' || isNaN(val) === false)? [(type !== 'string'? type+' ': '') + '%c' + val, base + css]: [val];
		},
	// check the requirements are met
		isValidLevel = function(level) {
			return (!level || level <= _DEBUG);
		};
	// don't deliver console.logging for unsupported browsers // TODO: add a log collection for these browsers?
	// IE 8/9 was freaking out here so i've added every possible check to see if console exists
	if (!window.console || 'undefined' === typeof console || 'function' !== typeof console.log) {
		return function noOp() {
			return false;
		};
	}
	// only deliver stylized logging for webkit browsers that support it (firebug also supports this, but we don't look for gecko+firebug atm)
	if (isWebkit && (!isSafari() || safariSupport())) {
		return function stylizedLogging(val, level) {
			if (isValidLevel(level)) {
				return console.log.apply(console, buildArr(val, level));
			}
		};
	}
	// failover to regular logging
	return function consoleLogging(val, level) {
		if (isValidLevel(level)) {
			return console.log.call(console, val);
		}
	};
}(isWebkit());

// set debug level
export function debugLevel(level) {
	if (_.isNumber(level)) {
		_DEBUG = level;
		debug('debug level = ' + level);
	}
	return _DEBUG;
}

/**
 * Get the current debug level
 * @returns {*|boolean}
 */

export function getDebugLevel(){
	return _DEBUG || false;
}
